<template>
    <div class="page">
        <div class="step">
            <div class="step-items">
                <div class="step-items1">1</div>
                <div class="step-items1-name">绑定</div>
            </div>
            <div class="step-items">
                <div class="step-items1 step-items2">2</div>
                <div class="step-items1-name">购买套餐</div>
            </div>
            <div class="step-items">
                <div class="step-items1 step-items2">3</div>
                <div class="step-items1-name">实名激活</div>
            </div>
        </div>
        <div class="u-form">
            <div class="name">卡号：</div>
            <div class="tip">卡板编号位于手机小卡的背面 </div>
            <img src="@/assets/img/icon16.png" mode="" />
            <div style="margin-top:24px;font-size:16px;">
                <span>卡号：</span><input placeholder="请输入卡号" border="bottom" v-model="iccid" />
            </div>
        </div>
        <van-button type="primary" round block color="#397EF5" @click="toLogin">下一步</van-button>
        <div class="u-form">
            <div class="name">温馨提示</div>
            <div class="tip1" style="margin-top:30upx;">输入卡号后，进行购买套餐并且实名认证 即可畅享网络。 </div>
            <div class="tip1">预充值卡系统自动订购每期流量套餐，请确保余额充足。 </div>
        </div>
    </div>
</template>

<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant';
import mixins from '@/mixins/mixins.js'
export default {
    data() {
        return {
            iccid: '',
            userPhone: '',
            code: localStorage.getItem('newCode'),
            noCode: ''
        }
    },
    mixins: [mixins],
    created() {
        this.userPhone = this.$route.query.userPhone ? this.$route.query.userPhone : localStorage.getItem('newUserPhone');
        this.noCode = this.$route.query.noCode ? this.$route.query.noCode : 0;
        if (this.$route.query.newLoginText) {
            this.iccid = this.$route.query.newLoginText;
            //   this.toLogin();
        } else if (localStorage.getItem('recordLoginText')) {
            this.iccid = localStorage.getItem('recordLoginText');
        }
    },
    methods: {
        toLogin() {
            wxRequest('/sim/select/send/title', { iccid: this.iccid }, 'post').then(res => {
                if (res.data.code === '200') {
                    Dialog.confirm({
                        title: "限时特惠活动",
                        message:"卡板购完成套餐后，联系客服即可领取20元余额，仅限24小时内有效 ！"
                    })
                        .then(() => { 
                            this.nextClick(this.iccid, this.userPhone, this.code, this.noCode, 0);
                        })
                } else {
                    this.nextClick(this.iccid, this.userPhone, this.code, this.noCode, 0);
                }
            })

        }
    }
}
</script>

<style lang="less" scoped>
.page {
    padding: 30px 0 20px;
    background: #F4F6FA;
    height: calc(100% - 50px);

    .step {
        width: 90%;
        margin: 0 auto;
        display: flex;
        position: relative;
        justify-content: space-between;

        &::after {
            display: block;
            content: '';
            height: 1px;
            width: 80%;
            border-top: 1px dashed #979797;
            position: absolute;
            top: 16px;
            left: 34px;
            z-index: 0;
        }

        .step-items {
            position: relative;
            z-index: 1;
        }

        .step-items1 {
            width: 33px;
            height: 33px;
            border-radius: 100%;
            text-align: center;
            line-height: 33px;
            color: #fff;
            margin: 0 auto;
            background: #397EF5;
        }

        .step-items2 {
            background: #A8B5CA;
        }

        .step-items1-name {
            height: 21px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 21px;
            margin-top: 10px;
        }
    }

    .u-form {
        width: calc(90% - 14px);
        padding: 25px 14px;
        margin: 23px auto;
        background: #fff;
        border-radius: 10px;

        .name {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #28292D;
            line-height: 20px;
        }

        .tip {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #63666D;
            margin-top: 9px;
            margin-bottom: 20px;
        }

        img {
            width: 358px;
            height: 118px;
        }

        .u-input {
            margin-top: 49px;
            border-bottom: 1px solid #F3F3F3;
        }

        .tip1 {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #63666D;
            text-indent: 28px;
            margin: 10px 0;
            line-height: 20px;
        }
    }

    .van-button {
        width: 90%;
        margin: 40px auto 0;
    }
}
</style>